var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Header'),_c('keep-alive',{attrs:{"include":"Home"}},[_c('router-view')],1),_c('VoucherIndexCenter',{staticStyle:{"z-index":"9999"},attrs:{"show":_vm.topUpShow},on:{"close":function($event){return _vm.close(false)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }